import { object, func } from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';

export const contextTypes = {
  selectedAreaStyle: object,
  saveScrollingElementWrapperRef: func,
};

export interface IWithLassoSelectedAreaStyle {
  selectedAreaStyle: object;
  saveScrollingElementWrapperRef: (element: InfiniteScroll) => void;
}
